import { More } from '#assets/svg';
import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { useExercisePresetRecoil } from '#states/exercisePresetsState';
import { produce } from 'immer';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { Tooltip } from 'src/shared/components/tooltip/Tooltip';
import { SetTypeChangeModal } from './SetTypeChangeModal';

interface SetTypeChangeProps {
  index: number;
}
export const SetTypeChange = ({ index }: SetTypeChangeProps) => {
  // 기입 방식 변경 모달 표시 여부
  const [isOpenSetType, setIsOpenSetType] = useState<boolean>(false);

  const { pathname } = useLocation();
  const isChartFormPage = pathname.includes('/chart/form');

  const { exercisePresets, setExercisePresets } = useExercisePresetRecoil();

  // chart form에 추가할 프리셋 정보
  const { records, setRecords } = useDashboardCharFormExerciseState();

  const setType = isChartFormPage
    ? records[index]?.sets[0]?.setType
    : exercisePresets?.exercisePresetWorkout[index]?.sets[0]?.setType;

  const onChange = (setType: 'REP' | 'REPWEIGHT' | 'REPTIME' | 'TIME') => {
    if (isChartFormPage) {
      setRecords(
        produce(draft => {
          draft[index].sets.map(set => (set.setType = setType));
        })
      );
    } else {
      setExercisePresets(
        produce(draft => {
          draft.exercisePresetWorkout[index].sets.map(
            set => (set.setType = setType)
          );
        })
      );
    }
  };

  const TooltipContent = () => {
    return (
      <div className="w-160 h-108 px-12 py-16  rounded-xl flex-col justify-center inline-flex">
        <div
          onClick={() => setIsOpenSetType(!isOpenSetType)}
          className="pb-16 text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable' border-b-1 border-solid border-[#2e2a3a]"
        >
          기입 방식 변경
        </div>
        <div
          onClick={() => {
            setExercisePresets(
              produce(draft => {
                draft.exercisePresetWorkout.splice(index, 1);
              })
            );

            setRecords(
              produce(draft => {
                draft.splice(index, 1);
              })
            );
          }}
          className="pt-16 text-[#e13a3a] text-[17px] font-medium font-['Pretendard Variable']"
        >
          운동 삭제
        </div>
      </div>
    );
  };

  return (
    <div className="h-44 w-44">
      <Tooltip
        tooltipContentStyle={{
          padding: '0px',
          borderRadius: '12px',
          background: '#262231'
        }}
        tooltipTrigger={
          <div className="h-44 w-44 p-3 bg-[#373245] rounded-[80px] justify-center items-center flex">
            <More />
          </div>
        }
        position="bottom-right"
      >
        <TooltipContent />
      </Tooltip>

      {isOpenSetType && (
        <SetTypeChangeModal
          setType={setType}
          onChange={onChange}
          onClose={() => setIsOpenSetType(false)}
        />
      )}
    </div>
  );
};
